module.exports = __webpack_public_path__ + "static/fonts/BMHANNAAir_otf.otf?f3d3e1c4";